import { useEffect, useState } from "react";

export function useIsTouch() {
  const [touch, setTouch] = useState(false);
  useEffect(() => {
    if (typeof window === "undefined") return;
    const hasTouch =
      "ontouchstart" in window ||
      (navigator && navigator.maxTouchPoints > 0) ||
      window.matchMedia("(hover: none)").matches;
    setTouch(hasTouch);
  }, []);
  return touch;
}
